import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F5F3ED', paddingTop: '80px' }}>
      <div className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-5xl font-light mb-8" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
          Privacy Policy
        </h1>
        
        <div className="bg-white rounded-lg p-8 shadow-sm mb-8">
          <p className="text-sm text-gray-500 mb-8">Last Updated: November 2025</p>
          
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                1. Introduction
              </h2>
              <p>
                Trove ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our investment platform and services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                2. Information We Collect
              </h2>
              <p className="mb-3">
                We collect information that you provide directly to us, including:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Personal Information:</strong> Name, email address, phone number, date of birth</li>
                <li><strong>Financial Information:</strong> Bank account details, investment preferences, financial goals</li>
                <li><strong>Identity Verification:</strong> Government-issued ID, proof of address</li>
                <li><strong>Usage Data:</strong> How you interact with our platform, device information, IP address</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                3. How We Use Your Information
              </h2>
              <p className="mb-3">
                We use your information to:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide and maintain our investment services</li>
                <li>Process transactions and manage your portfolio</li>
                <li>Comply with legal and regulatory requirements</li>
                <li>Communicate with you about your account and investments</li>
                <li>Improve our services and develop new features</li>
                <li>Prevent fraud and enhance security</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                4. Information Sharing and Disclosure
              </h2>
              <p>
                We do not sell your personal information. We may share your information with:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Service providers who assist in operating our platform</li>
                <li>Financial institutions for transaction processing</li>
                <li>Regulatory authorities as required by law</li>
                <li>Professional advisers including lawyers and auditors</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                5. Data Security
              </h2>
              <p>
                We implement industry-standard security measures to protect your information, including encryption, secure servers, and regular security audits. However, no method of transmission over the internet is 100% secure.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                6. Your Rights
              </h2>
              <p className="mb-3">
                You have the right to:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access and review your personal information</li>
                <li>Request corrections to your data</li>
                <li>Request deletion of your account (subject to legal obligations)</li>
                <li>Opt-out of marketing communications</li>
                <li>Lodge a complaint with the relevant data protection authority</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                7. Cookies and Tracking
              </h2>
              <p>
                We use cookies and similar tracking technologies to enhance your experience, analyze usage patterns, and personalize content. You can manage cookie preferences through your browser settings.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                8. Changes to This Policy
              </h2>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new policy on this page and updating the "Last Updated" date.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                9. Contact Us
              </h2>
              <p>
                If you have questions about this Privacy Policy or our data practices, please contact us at:
              </p>
              <p className="mt-3">
                <strong>Email:</strong> privacy@trove.com.au<br />
                <strong>Address:</strong> Level 12, 123 Collins Street, Melbourne VIC 3000
              </p>
            </section>
          </div>
        </div>

        <div className="text-center">
          <Link 
            to="/" 
            className="text-[#FF8C42] hover:text-[#FFB366] font-medium"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;